import { I_SegmentDetailInfos, I_FareInfos } from '@Redux/search/interfaces';
import { I_FareInfo } from '../interfaces/common';
import dayjs from 'dayjs';

// Date Formatting ============================
// 2023-01-25T06:35:00 輸出 01/25(三) 06:35
export const formatDateDayTime = (day: string) => {
    const date = dayjs(day).format('MM/DD');
    const week = formatWeekday(dayjs(day).format('dddd'));
    const time = dayjs(day).format('HH:mm');

    return `${date}(${week}) ${time}`;
};

// 2023-01-25T06:35:00 輸出 01月25日(三)
export const formatLocaleDateDay = (day: string) => {
    const month = dayjs(day).format('MM');
    const date = dayjs(day).format('DD');
    const week = formatWeekday(dayjs(day).format('dddd'));
    return `${month}月${date}日(${week})`;
};

// 2023-01-25T06:35:00 輸出 2022/01/01(一)
export const formatYearDateDay = (day: string) => {
    const date = dayjs(day).format('YYYY/MM/DD');
    const week = formatWeekday(dayjs(day).format('dddd'));
    return `${date}(${week})`;
};

// 2023-01-25T06:35:00 輸出 14:00
export const formatTime = (time: string) => dayjs(time).format('HH:mm');

// 2023-01-25T06:35:00 輸出 09/01
export const formatDate = (day: string) => dayjs(day).format('MM/DD');

// 星期轉換
export const formatWeekday = (week: string) => {
    switch (week) {
        case 'Monday':
            return '一';
        case 'Tuesday':
            return '二';
        case 'Wednesday':
            return '三';
        case 'Thursday':
            return '四';
        case 'Friday':
            return '五';
        case 'Saturday':
            return '六';
        case 'Sunday':
            return '日';
        default:
            return '一';
    }
};

// 移除 0h
export const formatHour = (time: string) => {
    if (!time) return null;
    const removeText = time.match(/^0h/g);
    if (!removeText || removeText?.length === 0) return time;
    return time.replace(removeText[0], '');
};

// Number Formatting ============================
// 將價格數字調整成對應國籍之數字顯示方式 (1000000 -> 1,000,000)
export const formatPrice = (price: number) => new Intl.NumberFormat().format(price);

// Data Display Formatting ======================
// 航段顯示文字 (URL 中的 Rtow)
export const displayRtow = (index: number, rtow: string) => {
    if (rtow == '3') return `第${index}段`;
    return index === 1 ? '去程' : '回程';
};

// 航段顯示去掉文字 (URL 中的 Rtow)
export const displayRtowNoText = (index: number, rtow: string) => {
    if (rtow == '3') return index.toString();
    return index === 1 ? '去程' : '回程';
};

// 含稅航段顯示文字 (ex. 大人xx含稅價)
export const displayTaxRtow = (rtow: string) => {
    if (!rtow) return '';
    switch (rtow) {
        case '0':
            return '';
        case '1':
            return '來回';
        case '3':
            return '全程';
    }
};

// 取得顯示艙等資訊文字
export const displayCabinInfo = (
    fareInfo: I_FareInfo[] | I_FareInfos[],
    seqNo: number,
    seqseqNo: number
) => {
    // search 頁航班明細只抓第一筆資料顯示 / confirmation 只會有單一筆
    const data = fareInfo[0].SegmentDetailInfos.filter(
        (seg: I_SegmentDetailInfos) => seg.SeqNo === seqNo && seg.SegSeqNo === seqseqNo
    );

    return `${data[0].CabinName}${data[0].BookingClass}`;
};

// 取得行李說明文字
export const displayLuggageInfo = (
    fareInfo: I_FareInfo[] | I_FareInfos[],
    seqNo: number,
    seqseqNo: number
) => {
    const info = fareInfo[0].SegmentDetailInfos.filter(
        (seg) => seg.SeqNo === seqNo && seg.SegSeqNo === seqseqNo
    );

    return info[0].BaggageDesc;
};

// 取得廉航手提行李說明文字
export const displayHandBaggageDesc = (
    fareInfo: I_FareInfo[] | I_FareInfos[],
    seqNo: number,
    seqseqNo: number
) => {
    const info = fareInfo[0].SegmentDetailInfos.filter(
        (seg) => seg.SeqNo === seqNo && seg.SegSeqNo === seqseqNo
    );

    return info[0].HandBaggageDesc;
};
